/**
 * HATCHD DIGITAL CLIENT SIDE APP
 *
 * DESCRIPTION:
 * This code has been developed in house at HATCHD DIGITAL.
 *
 * @author Hatchd Digital <hello@hatchd.com.au>
 * @see http://hatchd.com.au/
 * @contributor Jimmy Hillis <jimmy@hatchd.com.au>
 * @contributor Niaal Holder <niaal@hatchd.com.au>
 * @contributor Neil Ferreira <neil@hatchd.com.au>
 *
 */

import AccordionController from './accordion';
import SharkActivity from './shark_activity';
import loadGoogleMaps from './load_google_maps';
import PopupSlider from './popupslider';
import fitvids from "fitvids";
import '../../../node_modules/pinmap/dist/pinmap.min';
import 'slick-carousel';
import './shark_species';
import './article_navigation';
import './polyfills';

$(document).ready(() => {

  // Activate any sliders on the page
  $('.slide-facts ul').slick({
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 6,
    prevArrow: '<div class="slick-prev slick-arrow"></div>',
    nextArrow: '<div class="slick-next slick-arrow"></div>',
    responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
    ]
  });

  // Load document elements
  var $map = $('#shark_activity_map');

  // If there is a map, load shark activity on it
  if ($map.length) {

    loadGoogleMaps().then(() => {
      var $nav = $('#shark_activity_navigation');
      var popup_template = Handlebars.compile(jQuery.trim($('#shark_activity_popup').html()));
      var empty_template = Handlebars.compile(jQuery.trim($('#shark_activity_popup_empty').html()));
      var action_template = Handlebars.compile(jQuery.trim($('#shark_activity_popup_newalert').html()));


      var activity = new SharkActivity(
        '/shark-activity/detection-feed',
        '/static/images/icons/',
        popup_template,
        $map,
        empty_template,
        PopupSlider,
        action_template,
        '/shark-activity/alerts',
        '/api/ben-signs',
        '/api/safety-layers'
      );

      // Populate map ui from template
      var $ui = $('<div class="shark-activity-navigation" />').appendTo($map).append($nav.html());

      $ui.find('.filter-time').change(function () {
        activity.updateDateRange($ui);
      });

      // Load sightings
      activity.load($ui);
      activity.updateTweets();
    });

  }

  // Load any accordion blocks on the page
  new AccordionController().apply();

  // Apply mobile menu style hooks for nav and search
  $('.sitenav-toggle').click(function () {
    $('.sitenav-toggle').toggleClass('state-active');
    $('nav.sitenav-main').toggleClass('state-active');
  });
  $('.mobilesearch-toggle').click(function () {
    $('.sitesearch').toggleClass('state-active');
    $('.mobile-utilities-toggle').toggleClass('state-active');
    $('nav.sitenav-main').toggleClass('state-active');
  });

  // Facebook Sharing
  $('body').on('click', '.share-link--facebook', function (e) {
    if (FB) {
        FB.ui({
            method: 'share',
            href: window.location.href
        }, function (response) { });
        e.preventDefault();
    }
  });

  fitvids('.fitvids');

  // Loading Smartbanner.js if user agent does not match ServiceWA App i.e. PinnacleApp
  if (!navigator.userAgent.includes('PinnacleApp/')) {
      var url = "https://unpkg.com/smartbanner.js@1.14.6/dist/smartbanner.min.js";
      jQuery.getScript(url);
  }
});
